export default __webpack_public_path__ + "fc01a1589f57eba8bd22e2e5c2fe98d0.png";